import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { UserCard } from "components/Card/UserCard.jsx";

import { connect } from 'react-redux';
import { fetchUserInfo, changePassword } from 'reducers/user/userActions'
import Button from "components/CustomButton/CustomButton.jsx";
import { Link } from 'react-router-dom'

import avatar from "assets/img/faces/face-3.jpg";

class UserProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPassword: "",
      newPassword: "",
      repeatNewPassword: "",
      currentPasswordError: null,
      newPasswordError: null,
      repeatNewPasswordError: null
    };
  }

  componentWillMount() {
    this.props.fetchUserInfo();
  }

  handleCurrentPasswordChange(event) {
    this.setState({
      currentPassword: event.target.value
    });
    this.validateFieldRequired("currentPasswordError", event.target.value);
  }

  handleNewPasswordChange(event) {
    this.setState({
      newPassword: event.target.value
    });
    if (!this.validateFieldRequired("newPasswordError", event.target.value)) return;
    this.validatePasswordMatch(event.target.value, this.state.repeatNewPassword);
  }

  handleRepeatNewPasswordChange(event) {
    this.setState({
      repeatNewPassword: event.target.value
    });
    if (!this.validateFieldRequired("repeatNewPasswordError", event.target.value)) return;
    this.validatePasswordMatch(this.state.newPassword, event.target.value);
  }

  validateFieldRequired(fieldError, value) {
    if (value.length < 6) {
      this.setState({
        [fieldError]: (
          <small className="text-danger">
            Su contraseña debe tener al menos 6 caracteres
          </small>
        )
      })
      return false;
    } else {
      this.setState({ [fieldError]: null });
      return true;
    }
  }

  validatePasswordMatch(newPasswordValue, repeatNewPasswordValue) {
    if (newPasswordValue !== repeatNewPasswordValue) {
      let matchError = (<small className="text-danger">
        Las contraseñas no coinciden
    </small>);
      this.setState({
        repeatNewPasswordError: matchError,
        newPasswordError: matchError
      })
      return false;
    } else {
      this.setState({ repeatNewPasswordError: null, newPasswordError: null });
      return true
    }
  }

  clearFields() {
    this.setState({
      currentPassword: "",
      newPassword: "",
      repeatNewPassword: "",
      currentPasswordError: null,
      newPasswordError: null,
      repeatNewPasswordError: null
    })
  }

  handleChangePassword() {
    if (!this.validateFieldRequired("currentPasswordError", this.state.currentPassword)) return;
    if (!this.validateFieldRequired("newPasswordError", this.state.newPassword)) return;
    if (!this.validateFieldRequired("repeatNewPasswordError", this.state.repeatNewPassword)) return;
    if (!this.validatePasswordMatch(this.state.newPassword, this.state.repeatNewPassword)) return;
    let data = {
      currentPassword: this.state.currentPassword,
      newPassword: this.state.newPassword
    }
    this.props.changePassword(data);    
  }

  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={8}>
              <Card
                title=""
                content={
                  <form>
                    <FormInputs
                      ncols={["col-md-6", "col-md-6"]}
                      proprieties={[
                        {
                          label: "usuario",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Username",
                          value: this.props.user.username,
                          disabled: true
                        },
                        {
                          label: "Correo electrónico",
                          type: "email",
                          bsClass: "form-control",
                          placeholder: "Email",
                          value: this.props.user.email,
                          disabled: true
                        }
                      ]}
                    />

                    <FormInputs
                      ncols={["col-md-6", "col-md-6"]}
                      proprieties={[
                        {
                          label: "Nombre",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "First name",
                          value: this.props.user.firstName,
                          disabled: true
                        },
                        {
                          label: "Apellido",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Last name",
                          value: this.props.user.lastName,
                          disabled: true
                        }
                      ]}
                    />

                    <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          label: "Dirección",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Home Adress",
                          value: this.props.user.address,
                          disabled: true
                        }
                      ]}
                    />

                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
            <Col md={4}>
              <UserCard
                bgImage="https://ununsplash.imgix.net/photo-1431578500526-4d9613015464?fit=crop&fm=jpg&h=300&q=75&w=400"
                avatar={this.props.user.photoUrl}
                name={this.props.user.completeName}
                userName={this.props.user.username}
              />
            </Col>
          </Row>

          <Row>
            <Col md={8}>
              <Card
                title="Cambiar Contraseña"
                content={
                  <form>
                    <FormGroup>
                      <ControlLabel>Contraseña actual</ControlLabel>
                      <FormControl
                        placeholder="Contraseña actual"
                        name="current_password"
                        type="password"
                        value={this.state.currentPassword}
                        onChange={event => this.handleCurrentPasswordChange(event)}
                      />
                      {this.state.currentPasswordError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Nueva Contraseña</ControlLabel>
                      <FormControl
                        placeholder="Nueva Contraseña"
                        name="new_password"
                        type="password"
                        value={this.state.newPassword}
                        onChange={event => this.handleNewPasswordChange(event)}
                      />
                      {this.state.newPasswordError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Repetir Nueva Contraseña</ControlLabel>
                      <FormControl
                        placeholder="Repetir Nueva Contraseña"
                        name="repeat_new_password"
                        type="password"
                        value={this.state.repeatNewPassword}
                        onChange={event => this.handleRepeatNewPasswordChange(event)}
                      />
                      {this.state.repeatNewPasswordError}
                    </FormGroup>
                  </form>
                }
                legend={

                  <Button
                    bsStyle="info"
                    type="button"
                    fill
                    wd
                    onClick={() => this.handleChangePassword(this)}>
                    Cambiar Contraseña
                  </Button>
                }
              />
            </Col>
          </Row>

        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.data
});

export default connect(mapStateToProps, { fetchUserInfo, changePassword })(UserProfile);



// WEBPACK FOOTER //
// ./src/views/UserProfile/UserProfile.jsx